<template>
  <div v-if="article" class="teachers">
    <div
      v-if="article.image"
      :style="'background-image:url('+encodeURIComponent()+')'"
      class="hero"
    >
      <div class="hero-grad"></div>
    </div>
    <div class="section-3">
      <div class="_1200">
        <div class="box-side w-clearfix">
          <div class="big-white">
            <p class="paragraph-6">מאמר</p>
            <h2 class="head-tech">{{article.name}}</h2>
            <p class="author-name">{{article.author}}</p>
            <a v-if="article.link" :href="article.link" class="artilink">למאמר המקורי</a>
            <div class="paragraph-rtf-tech w-richtext" v-html="article.content"></div>
          </div>
          <div class="side-tech-box">
            <h3 class="side-tech-head sub">מאמרים נוספים</h3>
            <div v-for="article in articles" :key="article._id" class="collection-list-art">
              <div v-if="article._id!=$route.params.id" class="collection-item-art">
                <router-link
                  :to="'/article/'+article._id"
                  class="white-box art-flex w-inline-block w-clearfix"
                >
                  <div
                    class="art-thumbnail"
                    :style="article.image?'background-image:url('+article.image.url+')':''"
                  ></div>
                  <div class="innerart-box less-pad">
                    <!--<p class="white-box-above-head no-space-after">יחידה אקסטרנית</p>-->
                    <h4 class="white-box-head space">{{article.name}}</h4>
                    <p class="white-box-txt">{{article.author}}</p>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "article",
  data() {
    return {
      article: "",
      articles: []
    };
  },
  methods: {
    getArticle(id) {
      db.doc("/collections/OcYF8GHOC5M4cJc9Wm93/items/" + id)
        .get()
        .then(article => {
          this.article = article.data();
        });
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.getArticle(to.params.id);
    next();
  },
  created() {
    this.getArticle(this.$route.params.id);
    db.collection("/collections/OcYF8GHOC5M4cJc9Wm93/items")
      .get()
      .then(query => {
        console.log(query);
        query.forEach(doc => {
          var data = doc.data();
          data._id = doc.id;
          this.articles.push(data);
        });
      });
  }
};
</script>

<style scoped>
.collection-item-art {
  flex-basis: 100%;
}
h4 {
  max-height: 70px;
  overflow: hidden;
  font-size: 19px;
}
</style>
